// @flow

import { connect } from 'react-redux';
import React from 'react';
import styled from 'styled-components';
import ActionButtonComponent from '../../../actionButton';
import { isFormLoading as isLoadingSelector } from '../../../../store/form';
import type { Theme } from '../../../../types';

type OwnProps = {|
  buttonText: string,
  form: string,
|};

type StateProps = {|
  isLoading: Function,
|};

const ActionButton = styled<typeof ActionButtonComponent, Theme>(ActionButtonComponent)`
  align-self: flex-end;
`;

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const Submit = ({
  buttonText,
  form,
  isLoading,
}: Props) => (
  <ActionButton
    disabled={isLoading(form)}
    loading={isLoading(form)}
    variant="default"
  >
    {buttonText}
  </ActionButton>
);

const mapStateToProps = (state): StateProps => ({
  isLoading: (formKey: string) => isLoadingSelector(state, formKey),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(Submit);
